<script setup lang="ts">
import { useOnTimezoneChange } from '@entities/viewer'

import SectionCustomerDetails from './SectionCustomerDetails.vue'
import { useCustomerDetailsApi } from '../api/details.hook'

defineOptions({
  name: 'CustomerDetailsPage',
})

const route = useRoute()

useOnTimezoneChange(() => {
  void useCustomerDetailsApi({ customerId: route.params.id as string })
})
</script>

<template>
  <SectionCustomerDetails />
</template>
